module.exports = __webpack_public_path__ + "media/app/assets/mailers/discord-7c6045119993b8fe70333ea93815b395.png";